import {DataSource} from '@angular/cdk/table';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {catchError, finalize, take, takeUntil} from 'rxjs/operators';
import {CollectionViewer} from '@angular/cdk/collections';

import {User, UserSearchCriteria} from './user.model';
import {UserService} from './user.service';


export class UserListDataSource extends  DataSource<User> {

  private userSubject = new BehaviorSubject<User[]>([]);

  public totalCount$ = new BehaviorSubject<number>(0);

  constructor(private userService: UserService) { super(); }

  connect(collectionViewer: CollectionViewer): Observable<User[]> {
    return this.userSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.userSubject.complete();
    this.totalCount$.complete();
  }

  loadUsers(sortDirection = 'asc', pageIndex = 0, pageSize = 10, 
      userSearchCriteria : UserSearchCriteria) {
    this.userService.findUsers({
      page: pageIndex,
      size: pageSize,
      sort: sortDirection,
    },userSearchCriteria).pipe(
      catchError(() => of([])),
      finalize(() => {})
    ).pipe(take(1)).subscribe((response) => {
      this.totalCount$.next(response['body'].totalElements);
      this.userSubject.next(response['body'].content);
    });
  }

}
